import React, { Component } from "react";
import styles from "./Focus.css";
import { playChar } from "../../../../sounds/index";

export default class Focus extends Component {
  focusEl = null;

  componentDidUpdate = prevProps => {
    if (this.props.focused && !prevProps.focused) {
      this.focus();
    }
  };

  handleKeyUp = e => {
    this.props.move(e.keyCode);

    playChar(e.key);
  };

  handleFocus = () => this.props.setFocus();

  focus = () => {
    if (this.focusEl) {
      this.focusEl.focus();
    }
  };

  render = () => {
    return (
      <div
        className={styles.focus}
        onClick={this.handleFocus}
        onKeyUp={this.handleKeyUp}
        tabIndex="0"
        ref={el => {
          this.focusEl = el;
        }}
      />
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Cells/Cells/Prefilled/Focus.js